export const MOBILE_WIDTH = 400
export const MEDIUM_WIDTH = 600
